export default __webpack_public_path__ + "static/quote_icon-6d1df3ff3c08bb7b769beab8f00253b9.png";